import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.logout && _ctx.logout(...args))),
    class: "btn btn-default btn-flat float-right"
  }, " Sair "))
}